module.exports = __webpack_public_path__ + "static/media/seat-sl-selected.6f78dccb.svg";